import {
    apiRequest,
    PNSuploadSKPNS,
    PNSdetailCPNS,
} from "../../../../../services/adapters/kepegawaian/PNSService"

class DetailRepository {

    fetchUploadSk = async (query) => {
        return await apiRequest("post", PNSuploadSKPNS, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", PNSdetailCPNS, {
            params: query
        }, true)
    }
}

export default DetailRepository